<!--div *ngIf="!showMailView" class="row buttontop col-lg-12">
  <div *ngIf="!mentor" class="col-md-12">
    <div style="border-bottom: 1px solid #F0F0F0;padding:3px;">
      <td style="padding: 10px;">
        <button class="btn border" (click)="searchMember()" [disabled]="!searchmemberform.valid">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="clear()">Rensa</button>
      </td>
    </div>
  </div>
</div-->

<div *ngIf="!showMailView" class="d-flex d-justify-content-start ms-4 mt-3">
  <div class="d-flex d-justify-content-between gap-1">
    <button class="btn border" (click)="searchMember()" [disabled]="!searchmemberform.valid">Sök</button>
     <button class="btn border" (click)="clear()">Rensa</button>
  </div>
</div>

<hr class="ms-2 me-2">

<div *ngIf="!showMailView && countries && access?.role?.permissions">
 
  <form [formGroup]="searchmemberform" (keydown.enter)="searchMember();">
    <div *ngIf="role?.userPermissionLevel==='SY'">
      <mat-checkbox formControlName="onlyActiveMembers">Sök endast bland aktiva medlemmar</mat-checkbox>
    </div>
    <div class="ms-2 d-flex d-justify-content-start gap-2">
      <!--div [className]="mentor ? 'col-md-4' : 'col-xl-4 col-lg-4 col-md-4 col-sm-10'" style="max-width:250px;border:1px solid red;"-->
      <div style="min-width:350px;" class="mx-2">
        <mat-expansion-panel #panel class="accordionmargin" [expanded]=isExpanded>
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              {{title}}
              <p *ngIf="searchmemberform.invalid" style="color: red;position:absolute;right:200px;">Kontrollera sökvillkoren</p>
            </mat-panel-title>
        
          </mat-expansion-panel-header>
          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="memberId">
                Medlemsnummer
              </label>
              <input type="text" class="form-control form-control-sm cap" id="memberId" formControlName="memberId">
            </div>
           
              <div class="form-group">
                <label for="memberidFrom">
                  Från
                </label>
                <input type="text" class="form-control form-control-sm cap" id="memberidFrom" formControlName="memberIdFrom">
              </div>
              <div class="form-group">
                <label for="memberidTo">
                  Till
                </label>
                <input type="text" class="form-control form-control-sm cap" id="memberidTo" formControlName="memberIdTo">
              </div>
          </div>
          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="givenName">
                Förnamn
              </label>
              <input type="text" class="form-control form-control-sm cap" id="givenName" formControlName="givenName">
            </div>
            <div class="form-group">
              <label for="familyName">
                Efternamn
              </label>
              <input type="text" class="form-control form-control-sm cap" id="familyName" formControlName="familyName">
            </div>
          </div>
          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="homeCity">
                Postort
              </label>
              <input type="text" class="form-control form-control-sm cap" id="homeCity" formControlName="homeCity">
            </div>
            <div class="form-group">
              <label for="country">Land</label>
              <select class="form-control form-control-sm" id="country" formControlName="homeCountry">
                <option></option>
                <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
              </select>
            </div>
          </div>
          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="birthDate">
                Födelsedatum
              </label>
              <app-calendarnotrequired [form]="searchmemberform" formName="birthDate"></app-calendarnotrequired>
            </div>
              <div class="form-group">
                <label for="birthDateFrom">
                  Från
                </label>
                <app-calendarnotrequired [form]="searchmemberform" formName="birthDateFrom"></app-calendarnotrequired>
              </div>
              <div class="form-group">
                <label for="birthDateTo">
                  Till
                </label>
                <app-calendarnotrequired [form]="searchmemberform" formName="birthDateTo"></app-calendarnotrequired>
              </div>
            
          </div>
          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="institutionTypeId">
                Institutionstyp
              </label>
              <select class="form-control form-control-sm" id="institutionTypeId" formControlName="institutionTypeId">
                <option></option>
                <option *ngFor="let i of institutiontypes" [ngValue]="i.id">{{i.prefix}} - {{i.name}}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="institutionNumber">
                Institutionsnummer
              </label>
              <input type="text" class="form-control form-control-sm cap" id="institutionNumber" formControlName="institutionNumber">
            </div>
          </div>
          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="institutionName">
                Institutionsnamn
              </label>
              <input type="text" class="form-control form-control-sm cap" id="institutionName" formControlName="institutionName">
            </div>
            <div>
              <label>
                Ort
              </label>
              <input id="institutionCity" type="text" class="form-control form-control-sm cap" formControlName="institutionCity">
            </div>
            <button *ngIf="mentor" class="btn border" (click)="searchMember()" style="margin-left:20px;margin-top:20px;">Sök</button>
            <button *ngIf="mentor" class="btn border" (click)="cancel()" style="margin-top:20px;margin-left:20px;">Avbryt</button>
          </div>
        </mat-expansion-panel>
      </div>
      <div *ngIf="members.length > 0 && !showMailView" style="margin-top:-5px;">
        <div class="resultdiv">
          <p-menubar [model]="items">
           
              <div class="d-flex justify-content-between align-items-center gap-2">
              <span>Resultat: {{members?.length}}</span>
        
              <!--span *ngIf="!mentor && !mobiledevice && (access?.role?.permissions.includes('SEND_EMAIL') || access?.role?.permissions.includes('VIEW_POSTALS')) || id === 2058730" class="mr-2 ms-2">Välj alla:-->
<span *ngIf="(!mentor && !mobiledevice && (access?.role?.permissions.includes('SEND_EMAIL') || access?.role?.permissions.includes('VIEW_POSTALS'))) || id === 30127" class="mr-2 ms-2">
  Välj alla:
              <mat-checkbox #checkAll (change)="checkuncheckAll(checkAll);"></mat-checkbox>
              </span>
              </div>
            
          </p-menubar>
          <table matSort (matSortChange)="sortData($event)" class="table table-bordered border" matSortDisableClear=true>
            <thead role="rowgroup">
              <tr>
                <th mat-sort-header="id">Id</th>
                <th mat-sort-header="givenName">Förnamn</th>
                <th mat-sort-header="familyName">Efternamn</th>
                <th mat-sort-header="homeCity">Ort</th>
                <th mat-sort-header="institutionShortName">Institution</th>
                <th mat-sort-header="institutionName">Institution</th>
                <th *ngIf="(!mentor && (role?.permissions.includes('SEND_EMAIL') || role?.permissions.includes('VIEW_POSTALS'))) || id===30127" style="z-index:10000;width:60px;">Välj</th>
                
              </tr>
            </thead>
            <tr *ngFor="let m of members">
              <td style="text-align: right;">
                <a *ngIf="!mentor" class="table-link" [routerLink]="['/memberform/id/', m.id]">{{m.id}}</a>
                <a *ngIf="mentor" class="table-link" href="#" (click)="selectMember(m); $event.preventDefault();">{{m.id}}</a>
              </td>
              <td>{{m.givenName}}</td>
              <td>{{m.familyName}}</td>
              <td>{{m.homeCity}}</td>
              <td>{{m.institutionShortName}}</td>
              <td>{{m.institutionName}}</td>
              <td *ngIf="(!mentor && (role?.permissions.includes('SEND_EMAIL') || role?.permissions.includes('VIEW_POSTALS'))) || id === 30127">
                <div class="d-flex justify-content-between align-items-center">
                  <mat-checkbox *ngIf="!mentor" #inputEl (change)="add(m, inputEl);" [checked]="m.checked"></mat-checkbox>
                  <i *ngIf="m.email" class="fa fa-envelope-o mt-1" aria-hidden="true"></i>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </form>
  <div class="push"></div>
</div>
<div *ngIf="showMailView">
  <app-mail [memberlist]=etikettlist (closeEmail)="closeEmail($event)"></app-mail>
</div>
<div class=" row buttonbottom">
  <ng-template #childTemplate>
    <div style="margin-top:10px;">
      <span class="col-md-3">
        <button class="btn border" (click)="searchMember();">Sök</button>
      </span>
      <span class="col-md-3">
        <button class="btn border" (click)="clear()">Rensa</button>
      </span>
    </div>
  </ng-template>
  <app-footer *ngIf="!mentor" [childTemplate]="childTemplate"></app-footer>
</div>
